import { waitForWindowToClose } from '../../../pages/helper';

const MCP_OAUTH_CHANNEL = 'mcp-oauth';
const POPUP_CLOSED_GRACE_MS = 2000;

export type McpOAuthFlowEndReason = 'callback-completed' | 'popup-closed';

export const notifyMcpOAuthCallbackCompleted = () => {
  localStorage.setItem(MCP_OAUTH_CHANNEL, Date.now().toString());
};

export const waitForMcpOAuthFlowEnd = async (
  popup: Window,
): Promise<McpOAuthFlowEndReason> =>
  new Promise((resolve) => {
    let settled = false;

    const finish = (reason: McpOAuthFlowEndReason) => {
      if (settled) return;
      settled = true;
      window.removeEventListener('storage', handleStorage);
      localStorage.removeItem(MCP_OAUTH_CHANNEL);
      resolve(reason);
    };

    const handleStorage = (event: StorageEvent) => {
      if (event.key === MCP_OAUTH_CHANNEL) {
        finish('callback-completed');
      }
    };

    window.addEventListener('storage', handleStorage);

    // Some OAuth providers isolate the popup with Cross-Origin-Opener-Policy,
    // which can make popup.closed look true before the callback finishes.
    setTimeout(() => {
      if (!popup.closed) {
        waitForWindowToClose(popup).then(() => finish('popup-closed'));
      }
    }, POPUP_CLOSED_GRACE_MS);
  });
